const subscription = {
    limit_exceeded: 'Вы достигли лимита вашего плана подписки.',
    get_plan_failed: 'Не удалось получить план подписки для арендатора.',
    tenant_suspended: 'Арендатор приостановлен. Пожалуйста, свяжитесь с администратором.',
};
export default Object.freeze(subscription);
